"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
const en_1 = __importDefault(require("./en"));
const invoice_1 = require("../constants/invoice");
const currency_1 = require("../constants/currency");
const parse_1 = require("../utils/parse");
const INVOICE_PERIOD_FLAG = 'Bill for services supplied during:';
const INVOICE_PERIOD_DATE_SEPARATOR = '-';
const INVOICE_NAME_FLAG = 'Supplier:';
const COMPANY_NAME = 'Deliveroo Australia Pty Ltd';
const getPeriod = ({ text, zone }) => {
    const [start, end] = text[text.indexOf(INVOICE_PERIOD_FLAG) + 1]
        .split(INVOICE_PERIOD_DATE_SEPARATOR)
        .map((date) => luxon_1.DateTime.fromFormat(date.trim(), invoice_1.INVOICE_DATE_FORMAT, { zone }));
    return {
        start,
        end: end.endOf('day'),
    };
};
const getName = ({ text }) => parse_1.getNameFromHeader(text, INVOICE_NAME_FLAG, 1);
exports.default = Object.assign(Object.assign({}, en_1.default), { getName,
    getPeriod, currency: currency_1.AUD, flags: { with: [COMPANY_NAME] } });
//# sourceMappingURL=en-AU.js.map